import React from "react";
import {
  SearchInputComponent,
} from "../../../../../common/components";
import { LeadFilterProps } from "./lead-filter.props";
import "./lead-filter.scss";
import { useResourcePermissions } from "../../../../../common/hooks/resource-permissions";
import MODULES from "../../../../../constants/modules";
import Button from "../../../../../common/components/button/button";

const LeadFilter: React.FC<LeadFilterProps> = (props: any) => {
  const {
    onSearch,
    searchRef,
    isResetSearch,
    handleClickCreateNewForm,
  } = props;
  const { canWrite} = useResourcePermissions(
    MODULES.VIEW_SURVEYS
  );

  return (
    <div className="lead-capture-lead-list-search-filter-wrapper">
      <div className="lead-capture-lead-list-search-wrapper">
        <SearchInputComponent
          placeholder="Search by First Name, Last Name, Email and Mobile Number"
          onSearch={onSearch}
          isReset={isResetSearch}
          ref={searchRef}
        />
      </div>
      <div className="lead-capture-lead-list-filter-wrapper">
        {canWrite && (
          <div className="lead-capture-lead-list-create-filter">
            <Button
            label="Create New Form"
            onClick={handleClickCreateNewForm}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default LeadFilter;
